const recipientHtml = require("./html/recipient.html");
import $ from "jquery";
import {setElementsFromScope, setOptionsForSelect} from "../../../utilities/selectorHelpers";
import QuickBtnGroup from "../../../components/QuickBtnGroup/QuickBtnGroup";
import timePicker from "../../../components/timePicker/timePicker";
import render from "../../../utilities/render";
import run from '../../../utilities/run';
import {getESTDate} from "../../../utilities/general";
import {displayCustomReporting} from "./reportsUtil";
import moment from "moment";
require("./reports.less");

let scheduleReportUrl = null;
let reportId = null;
let receiptCount = 2;

export default function loadModal(getReportParamsUrl, inpScheduleReportUrl,
  crtId, reportParamInput, scheduleParams, onSubmitSuccessCallback) {
  const error={};

  scheduleReportUrl = inpScheduleReportUrl;
  reportId = crtId;

  let searchRequest = $.ajax({
    url: getReportParamsUrl,
    type: 'POST',
    data: {reportId: crtId},
    dataType: 'JSON',
    // DONT DO THIS
    // async: false,
    success: function(reportParams) {
      const scheduleModal = $(render(
        require("../../../sharedHtml/modal.html"),
        {
          title:'Report Scheduling',
          footerBtns:'<a href="#" class="base-btn v2-btn purple-btn m-close-btn">Cancel</a>\
          <a href="#" class="base-btn purple-btn schedule-report-btn">Schedule</a>',
          body:require('./html/scheduleModal.html'),
          modalDialogClass:'q-modal-dialog-800'
        }
      ));
      //Destroy modal on hide
      scheduleModal.on('hidden.bs.modal', function () {
          $(this).data('bs.modal', null);
          scheduleModal.remove();
      });

      setupModal(scheduleModal, reportParams, reportParams.paramDetails,
              reportParamInput, scheduleParams, onSubmitSuccessCallback);
    },
    error: error
  });
}

const elementsMap = {
  scheduleModalForm: '.scheduleModalForm',
  addRecipientButton: '.add-recipient',
  deleteRecipientButton: '.delete-recipient',
  recipients: '#recipients',
  action: '#action',
  jobId: '#jobId',
  //Schedule Name
  scheduleName: '#scheduleName',
  //Date Range
  dateRange: '.modal-report-range-selector',
  //Warehouse
  warehouseSelect: '.warehouse-select',
  //Schedule Channel
  scheduleChannelAll: '#scheduleChannelAll',
  scheduleChannelSpecific: '#scheduleChannelSpecific',
  scheduleChannel: '#scheduleChannel',
  //Schedule Product
  scheduleProductAll: '#scheduleProductAll',
  scheduleProductSpecific: '#scheduleProductSpecific',
  scheduleProduct: '#scheduleProduct',
  //Schedule Times
  runDailySched: `#runDailySched`,
  runWeeklySched: `#runWeeklySched`,
  runMonthlySched: `#runMonthlySched`,
  runQuarterlySched: `#runQuarterlySched`,
  runFreqSel: `.modal-run-freq-selector`,
  //Weekly Schedule Handlers
  weeklyScheduleButtons: ".modal-schedule-day-toggler .q-btn-cube",
  //Day of Month Handlers
  dayOfMonth: `#dayOfMonth`,
  specificDay: `#specificDay`,
  specificDayDiv: `#specificDayDiv`,
  //End Date
  endDateSel: `.modal-schedule-end-date-selector`,
  endDateDiv: `.end-date-input-div`,
  endDateInp: `#endDateInput`,
  //Cancel/Schedule
  cancelButton: `.m-close-btn`,
  scheduleButton: `.schedule-report-btn`,
  //Recipients
  recipientEmails: ".schedule-modal-recipients-input",
  //Time Pickers
  timePickerZone: `.modal-time-zone-selector`,
  dailyTimeEl: `.time-picker-daily-run`,
  weeklyTimeEl: `.time-picker-weekly-run`,
  //Run Days Selectors
  scheduleDayToggler: `.modal-schedule-day-toggler `,
  selectedCubes: `.q-btn-cube.active`,
  dayCubes: `.q-btn-cube`,
}

function setupModal(scheduleModal, reportParams, reportParamDetails,
    reportParamInput, scheduleParams, onSubmitSuccessCallback=function(){}) {
    //console.log('calling loadModal');
    //console.log('setupModal.reportParamInput - ', reportParamInput);
    //console.log('setupModal.scheduleParams - ', scheduleParams);

    const mainEl = $('.reports-outer');
    const reportParamsModalInputAnchor = scheduleModal.find('#reportParamsModalInputAnchor');
    const modalDaysBtnGroupEl = scheduleModal.find('.modal-schedule-day-toggler');
    const modalDaysBtnGroup = new QuickBtnGroup(modalDaysBtnGroupEl, {multi:true});
    modalDaysBtnGroup.init();

    displayCustomReporting(mainEl, reportParamsModalInputAnchor, reportParams,
       reportParamDetails, reportParamInput, true);

    function showScheduleReportModal() {
      scheduleModal.modal("show");
    }

    function hideScheduleReportModal() {
      scheduleModal.modal("hide"); 
    }

    const els = {};

    setElements();
    setValidator();

    els.dailyTimePicker = timePicker(els.dailyTimeEl);
    els.weeklyTimePicker = timePicker(els.weeklyTimeEl);

/*
    let timePickerWeeklyRun = scheduleModal.find('.time-picker-weekly-run');
    timePickerWeeklyRun = timePicker(timePickerWeeklyRun);
    console.log('timePickerWeeklyRun: ', timePickerWeeklyRun);
*/

    function setValidator(){
      const validator = els.scheduleModalForm.validate({
        errorPlacement: function(error, element) {
          let appendClosest = $(element).data('error-placement-append-closest');
          if (appendClosest) {
            $(element).closest(appendClosest).append(error);
          } else {
            error.insertAfter(element);
          }
        },
      });
      validator.settings.ignore = ":disabled,:hidden";
    }

    function loadJobData() {
      if (scheduleParams && scheduleParams.jobId) {
        els.jobId.val(scheduleParams.jobId);
        els.action.val('Update');
        els.scheduleName.val(scheduleParams.jobName);
        els.scheduleName.prop('disabled', true);
        els.runFreqSel.val(scheduleParams.runFrequency).trigger('change');

        if (scheduleParams.jobEndDate) {
          els.endDateInp.val(scheduleParams.jobEndDate);
          els.endDateSel.val('schedEndDate').trigger('change');
          onEndDateSelChanged();
        }

        els.dailyTimePicker.setTimeFromMilitary(scheduleParams.runTime);
        els.weeklyTimePicker.setTimeFromMilitary(scheduleParams.runTime);

        if (scheduleParams.runFrequency == 'Weekly') {
          let dayEls = els.scheduleDayToggler.find(elementsMap.dayCubes);
          dayEls.removeClass("active");
          dayEls.each(function(idx, el) {
            let btn = $(el);
            let day = btn.data("qb-key");
            let days = scheduleParams.commaSepDays;
            if (day == 'Sunday' && days.indexOf("1") >= 0) {
              btn.addClass("active");
            }
            if (day == 'Monday' && days.indexOf("2") >= 0) {
              btn.addClass("active");
            }
            if (day == 'Tuesday' && days.indexOf("3") >= 0) {
              btn.addClass("active");
            }
            if (day == 'Wednesday' && days.indexOf("4") >= 0) {
              btn.addClass("active");
            }
            if (day == 'Thursday' && days.indexOf("5") >= 0) {
              btn.addClass("active");
            }
            if (day == 'Friday' && days.indexOf("6") >= 0) {
              btn.addClass("active");
            }
            if (day == 'Saturday' && days.indexOf("7") >= 0) {
              btn.addClass("active");
            }
          });
        }

        els.dayOfMonth.val(scheduleParams.dayOfMonth);
        els.specificDay.val(scheduleParams.specificDay);

        let emails = scheduleParams.email.split(';');
        let emailElArray = els.recipientEmails.toArray();
        emails.forEach(function(email, index) {
          if (index < emailElArray.length) {
            $(emailElArray[index]).val(email);
          } else {
            let emailEl = onAddRecipientClick();
            emailEl.val(email);
          }
        });
        //console.log('emails: ', emails);
        //onAddRecipientClick

        // recipients
        //console.log("reqData: ", reqData)
      } else {
        els.action.val('Create');
      }
    }

    function setElements(){
      setElementsFromScope(els, elementsMap, scheduleModal);
      els.scheduleModal = scheduleModal;
    }

    els.addRecipientButton.on('click', onAddRecipientClick);
    els.deleteRecipientButton.on('click', onRemoveRecipientClick);

    function onAddRecipientClick() {
      let recipRow = $(render(recipientHtml, { index: receiptCount}));
      receiptCount++;
      recipRow.appendTo($(els.recipients));
      $(recipRow).find(".delete-recipient").on('click', onRemoveRecipientClick);
      return recipRow.find('.schedule-modal-recipients-input');
    }

    function onRemoveRecipientClick() {
      $(this).closest(".recipient-row").remove();
    }

    //
    // Frequency Selector Handlers
    //
    els.runFreqSel.on('change', onFreqSelChanged);
    els.runFreqSel.select2();

    function onFreqSelChanged() {
      let val = els.runFreqSel.val();

      if (val == 'Daily') {
        els.runDailySched.show();
        els.runWeeklySched.hide();
        els.runMonthlySched.hide();
        els.runQuarterlySched.hide();
      } else if (val == 'Weekly') {
        els.runDailySched.hide();
        els.runWeeklySched.show();
        els.runMonthlySched.hide();
        els.runQuarterlySched.hide();
      } else if (val == 'Monthly') {
        els.runDailySched.hide();
        els.runWeeklySched.hide();
        els.runMonthlySched.show();
        els.runQuarterlySched.hide();
      } else if (val == 'Quarterly') {
        els.runDailySched.hide();
        els.runWeeklySched.hide();
        els.runMonthlySched.hide();
        els.runQuarterlySched.show();
      } else {
        console.error('invalid frequency selected');
      }
    }

    //
    // Day of Month Handler
    //
    els.dayOfMonth.on('change', onDayOfMonthSelChange);
    els.dayOfMonth.select2();
    els.specificDay.select2();

    function onDayOfMonthSelChange() {
      let val = els.dayOfMonth.val();

      if (val === 'SpecificDay') {
        els.specificDayDiv.show();
      } else {
        els.specificDayDiv.hide();
      }
    }

    //
    // Time Zone Picker
    //
    els.timePickerZone.select2();

    //
    // End Date Handlers
    //
    els.endDateSel.on('change', onEndDateSelChanged);
    els.endDateSel.select2();

    function onEndDateSelChanged() {
      let val = els.endDateSel.val();
      //console.log('End Date Sel Val: ', val);

      if (val === 'noSchedEndDate') {
        els.endDateDiv.hide();
      } else {
        els.endDateDiv.show();
      }
    }

    els.endDateInp.datepicker({
      startDate: new Date(),
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true
    });

    //
    // Cancel Button Handler
    //
    els.cancelButton.on('click', onCancelButtonClick);

    function onCancelButtonClick(e) {
      e.preventDefault();
      hideScheduleReportModal();
    }

    //
    // Schedule Button Handler
    //
    els.scheduleButton.on('click', onScheduleButtonClick);

    function onScheduleButtonClick(e) {
        e.preventDefault();
        if(isModalValid()){
          scheduleOrUpdateReport();
          //hideScheduleReportModal();
        }
    }

    function isModalValid(){
      let isValid = false;
      if (els.scheduleModalForm.valid()) {
        isValid = true;
      }

      if(els.runFreqSel.val()=='Daily' &&els.endDateSel.val()=='schedEndDate') {
        let now = moment(getESTDate(new Date()), 'MM/DD/YYYY HH:mm:ss');
        let dailyTimePicker = timePicker(els.dailyTimeEl);
        let endDateSelectedStr=els.endDateInp.val()+" "+dailyTimePicker.getMilitaryTime()+":00";
        let endDateSelectedMoment = moment(endDateSelectedStr, 'MM/DD/YYYY HH:mm:ss');
        if (endDateSelectedMoment.isBefore(now) ) { 
          if(now.startOf('day').isSame(endDateSelectedMoment.startOf('day'))){
              var errName = $("#invalidTime"); 
              errName.show();
              errName.html("<label class='error'>Invalid Time</label>");              
            }else{
              var errName = $("#invalidDate");
              errName.show();
              errName.html("<label class='error'>Invalid End Date</label>");              
            }          
          isValid = false;
        }
    }
    
      return isValid;
    }
    function getSelectedDays() {
      let dayEls = els.scheduleDayToggler.find(elementsMap.selectedCubes);
      let selectedDays = [];
      dayEls.each(function(idx, el) {
        let btn = $(el);
        selectedDays.push(btn.data("qb-key"));
      });
      return selectedDays;
    }

    function scheduleOrUpdateReport() {
      let self = this;
      let domain = $("#add-domain-name").val();

      let reqData = {
        "scheduleName": els.scheduleName.val() || "",
        "scheduleChannel": els.scheduleChannel.val() || "",
        "scheduleProduct": els.scheduleProduct.val() || "",
        "selectedDays": getSelectedDays(),
        "endDate": els.endDateInp.val() || "",
        "reportId": reportId,
        "dayOfMonth": els.dayOfMonth.val(),
        "specificDay": els.specificDay.val(),
        "action": els.action.val(),
        "userAction": els.action.val(),
        "jobId": els.jobId.val(),
        "frequency": els.runFreqSel.val(),
      };

      let zone = els.timePickerZone.val();
      if (zone == null || zone === "") zone = "EST";

      if (reqData.frequency == "Daily") {
        reqData.scheduleTime = els.dailyTimePicker.getMilitaryTime() + " " + zone;
      } else if (reqData.frequency == "Weekly") {
        reqData.scheduleTime = els.weeklyTimePicker.getMilitaryTime() + " " + zone;
      }

      //console.log("reqData: ", reqData)

      reportParams.content.forEach(function (value) {
        if(value.crpKey == 'DATE_RANGE'){
          let data = reportParamsModalInputAnchor.find(`#${value.crpKey}`).val();
          let data1 = reportParamsModalInputAnchor.find(`#${value.crpKey}1`).val();
          let data2 = reportParamsModalInputAnchor.find(`#${value.crpKey}2`).val();
          reqData[value.crpKey] = data;
          reqData[value.crpKey + "1"] = data1;
          reqData[value.crpKey + "2"] = data2;
        }else{
          let el = reportParamsModalInputAnchor.find(`#${value.crpKey}`);
          let data = el.val();
          if(el.hasClass('split-button') && data === '#'){
            data = reportParamsModalInputAnchor.find(`#${value.crpKey}-values`).val().join(",");
          }
          reqData[value.crpKey] = data;
        }

      });

      let recStr = '';
      let first = true;
      scheduleModal.find(elementsMap.recipientEmails).each(function(index) {
        if (!first) recStr = recStr + ';'
        else first = false;
        recStr = recStr + this.value;
      });

      reqData.recipients = recStr;

      $.ajax({
        url: scheduleReportUrl,
        type: 'POST',
        data: reqData,
        dataType: 'JSON',
        async: true,
        success: function(response){
          hideScheduleReportModal();
          location.reload();
          onSubmitSuccessCallback(response);
        },
        error: function(response) {
          //console.log('Error on response from scheduleReport: ', response);
        }
      });
    }

    loadJobData();
    onFreqSelChanged();
    onEndDateSelChanged();
    onDayOfMonthSelChange();
    showScheduleReportModal();

    // scheduleModal.find(".select2-select").each(function(curElem) {
    //   $(curElem).select2();
    // });
};



// WEBPACK FOOTER //
// ./src/pages/report/lookup/scheduleReportModal.js